module.exports = __webpack_public_path__ + "img/library.d68447a.svg";